<template>
    <div class="pend-warning">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入站点名称或告警内容" :search-submit="$_getTableList">
                </mc-search-bar>
            </template>
            <template slot="right">
                <el-button class="mc-search-bar-btn" type="danger" @click="dialog.allDelete.methods.open()">全部删除
                </el-button>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label"
                    :width="tableOption.head[0].width" v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.occure_at)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label"
                    :width="tableOption.head[1].width" v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="deal-item"
                            @click="dialog.siteName.methods.open(scope.row)">{{scope.row.site_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label"
                    :width="tableOption.head[2].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label"
                    :width="tableOption.head[3].width" v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.severity == 0"></span>
                        <span v-else-if="scope.row.severity == 1">正常</span>
                        <span v-else-if="scope.row.severity == 2">一般</span>
                        <span v-else-if="scope.row.severity == 3">紧急</span>
                        <span v-else-if="scope.row.severity == 4">严重</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label"
                    :width="tableOption.head[4].width" v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span @click="dialog.warning.methods.open(scope.row)"
                            class="deal-item content">{{scope.row.content}}</span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <!-- <mc-pager :pager-option.sync="pager" ref="site-managing-pager" @getList="$_getTableList"></mc-pager> -->

        <mc-dialog :dialog-option.sync="dialog.allDelete">
            <template slot="content">
                <mc-label icon="el-icon-error" error>删除后不可恢复，确定删除全部告警信息？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.delete">
            <template slot="content">
                <mc-label icon="el-icon-error" error>删除后不可恢复，确定删除这条告警信息？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.siteName">
            <template slot="content">
                <mc-layout-row label-text="站点名称" :labelWidth="120">
                    <mc-label info>{{site.site_name}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="省" :labelWidth="120">
                    <mc-label info>{{site.province}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="市" :labelWidth="120">
                    <mc-label info>{{site.city}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="地址" :labelWidth="120">
                    <mc-label info>{{site.address}}</mc-label>
                </mc-layout-row>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.warning">
            <template slot="content">
                <mc-label info>{{this.dialog.warning.data.content}}</mc-label>
            </template>
        </mc-dialog>


    </div>
</template>

<script>
    export default {
        name: "pend-warning",
        data() {
            return {
                searchParmas: '',
                site: [],
                // pager: {
                //     page: 1,
                //     per_page: 10,
                //     per_pages: [10, 20, 30, 40, 50],
                //     total: 0,
                // },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: true,
                        label: "操作",
                        items: [{
                            label: "删除",
                            type: "danger",
                            size: 'mini',
                            click: (index, row) => {
                                this.dialog.delete.methods.open(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "occure_at",
                            label: "告警时间",
                            width: "150",
                        },
                        {
                            prop: "site_name",
                            label: "告警站点",
                            width: "",
                        },
                        {
                            prop: "host",
                            label: "告警对象",
                            width: "",
                        },
                        {
                            prop: "severity",
                            label: "告警级别",
                            width: "80",
                        },
                        // {
                        //     prop: "status",
                        //     label: "工单状态",
                        //     width: "80",
                        // },
                        {
                            prop: "content",
                            label: "告警内容",
                            width: ""
                        },
                    ],
                    data: [],
                },
                dialog: {
                    allDelete: {
                        visible: false,
                        title: "删除全部告警信息",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.allDelete.visible = true;
                            },
                            confirm: () => {
                                this.$_deleteAllWarning()
                            }
                        },
                        data: {},
                    },
                    delete: {
                        visible: false,
                        title: "删除告警信息",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.delete.data.row = item
                                this.dialog.delete.visible = true;
                            },
                            confirm: () => {
                                this.$_deleteWarning(this.dialog.delete.data.row.id)
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                    siteName: {
                        visible: false,
                        title: "站点详情",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (row) => {
                                this.dialog.siteName.data.id = row.site_id;
                                this.$_getSite(row.site_id);
                                this.dialog.siteName.visible = true;
                            },
                        },
                        data: {
                            id: "",
                        },
                    },
                    warning: {
                        visible: false,
                        title: "告警内容",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.warning.data.content = item.content;
                                this.dialog.warning.visible = true;
                            },
                        },
                        data: {
                            content: "",
                        },
                    },
                }
            }
        },
        mounted() {
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    search: this.searchParmas,
                    // page: this.pager.page,
                    // per_page: this.pager.per_page
                }
                let data = await this.$api.adminPendWarning.getList.getPendList.call(this, params);
                if (data !== false) {
                    this.tableOption.data = data;
                    //   this.tableOption.data = {
                    //       data:{
                    //       occure_at:"2019-01-30 22:35:07",
                    //       site_name:"玉环市民卡有限公司-OKP",
                    //       host:"玉环市民卡有限公司-OKP",
                    //       告警级别:1,
                    //       告警内容:"okp 主机 has lost heartbeat"
                    //   }
                    //   };
                    // this.pager.total = data.total;
                }
                this.tableOption.loading = false;

            },
            $_deleteWarning: async function (row) {
                let params = {
                    id: row
                }
                let data = await this.$api.adminPendWarning.do.deleteWarning.call(this, params);
                if (data !== false) {
                    this.dialog.delete.visible = false;
                    this.$_getTableList();
                    this.$message.success("删除成功");
                }
            },
            $_deleteAllWarning: async function (row) {
                let params = {}
                let data = await this.$api.adminPendWarning.do.allDelete.call(this, params);
                if (data !== false) {
                    this.dialog.allDelete.visible = false;
                    this.$_getTableList();
                    this.$message.success("删除成功");
                }
            },
            $_getSite: async function () {
                let params = {
                    site_id: this.dialog.siteName.data.id
                }
                let data = await this.$api.adminPendWarning.getList.getSite.call(this, params);
                if (data !== false) {
                    this.site = data;
                }
            },
            $_handleTime(time) {
                let origindate = Date.parse(time);
                let date = new Date(origindate + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
                // return date;
            }
        },
        // watch: {
        //     pager: {
        //         deep: true,
        //         handler: function () {
        //             this.$_getTableList();
        //         },
        //     },
        // }
    }
</script>


<style lang="less" scoped>
    .pend-warning {
        width: 100%;


        .deal-item {
            cursor: pointer;
            color: #1890FF;
        }

        .content {
            min-width: 400px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>